import clsx from "clsx";

const RecaptchaNotice = ({ className = "" }) => {
  const classes = clsx("text-muted small", className);

  return (
    <p className={classes}>
      By continuing you agree to the NeoReach{" "}
      <a href="/privacy">Privacy Policy</a> and{" "}
      <a href="/terms">Terms & Conditions</a>. This site is protected by
      reCAPTCHA and the Google{" "}
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </p>
  );
};

export default RecaptchaNotice;
